import React from 'react';

import { Header, Footer, ScrollTop, ScrollToTop } from './components';
import { HomePage, AboutUs, TestimonialsPage, BlogGrid, BlogList, BlogSingle, Login, Register, ForgotPwd, ShopGrid, ShopList, Cart, Checkout, Contact, ProductSingle, Wishlist, ServiceSingle, TeamPage, ServicePage, OrderConfirmation, FaqPage, CareerPage, CareerSingle, CareerForm, TeamSingle, Gallery, PricingPage, ProcessPage, QuotePage, ProjectPage, ProjectSingle, PartnerPage } from './sections';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';



const App = () => {

  return (

    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        <Route path='/Team' element={<TeamPage />} /> 
        <Route path='/Team/:id' element={<TeamSingle />} />
        <Route path='/Team/Team-Single' element={<TeamSingle />} />
        <Route path='/Testimonials' element={<TestimonialsPage />} />
        <Route path='/Faqs' element={<FaqPage />} />

        {/*Pages*/}
        <Route path='/Gallery' element={<Gallery />} />
        <Route path='/Pricing' element={<PricingPage />} />
        <Route path='/Process' element={<ProcessPage />} />

        <Route path='/Careers' element={<CareerPage />} />
        <Route path='/Careers/:id' element={<CareerSingle />} />
        <Route path='/Careers/Position-Single' element={<CareerSingle />} />
        <Route path='/Career-Form' element={<CareerForm />} />

        <Route path='/Get-Quote' element={<QuotePage />} />
        <Route path='/Partners' element={<PartnerPage />} />

        {/*Services*/}
        <Route path='/Services' element={<ServicePage />} />
        <Route path='/Services/:id' element={<ServiceSingle />} />
        <Route path='/Services/Service-Single' element={<ServiceSingle />} />

        {/*Projects*/}
        <Route path='/Projects' element={<ProjectPage />} />
        <Route path='/Projects/:id' element={<ProjectSingle />} />
        <Route path='/Projects/Project-Single' element={<ProjectSingle />} />

        {/*Blogs*/}
        <Route path='/Blog-grid' element={<BlogGrid />} /> 
        <Route path='/Blogs/category/:category' element={<BlogList />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogList />} /> 
        <Route path='/Blogs/search/:search' element={<BlogList />} /> 
        <Route path='/Blog-list' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} />

        {/*Shop*/}
        <Route path='/Shop-grid' element={<ShopGrid />} />  
        <Route path='/Shop/category/:category' element={<ShopList />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopList />} /> 
        <Route path='/Shop/search/:search' element={<ShopList />} /> 
        <Route path='/Shop-list' element={<ShopList />} />
        <Route path='/Shop/:id' element={<ProductSingle />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle />} /> 
        <Route path='/Wishlist' element={<Wishlist />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/Checkout' element={<Checkout />} />
        <Route path='/OrderConfirmation' element={<OrderConfirmation />} />
        <Route path='/Login' element={<Login />} />  
        <Route path='/Register' element={<Register />} /> 
        <Route path='/Forgot-pwd' element={<ForgotPwd />} /> 

        {/*Contact*/}
        <Route path='/Contact-us' element={<Contact />} /> 

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      <ToastContainer />
      
    </div>

  )
}

export default App;
